import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-poppins selection:bg-syana-blue-100 selection:text-syana-blue-900 pt-20 text-left">
      {/* Main Content */}
      <main className="py-20 px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto bg-white p-10 lg:p-16 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
        >
          <div className="space-y-4 mb-12">
            <h1 className="text-3xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              Terms of Use
            </h1>
            <p className="text-slate-400 text-sm font-medium">Last updated: October 2025</p>
          </div>

          <div className="space-y-10 text-slate-600 leading-relaxed text-base lg:text-lg text-left">
            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">1. Acceptance of Terms</h2>
              <p>
                By accessing and using this website or our services, you agree to comply with and be bound by these Terms of Use. If you do not agree, please refrain from using our services.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">2. Professional Services</h2>
              <p>
                Siyane Optometrists provides clinical eye care services, consultations, and prescriptions. All clinical advice is provided by registered medical professionals. Prescriptions are valid for a limited time and should be updated as recommended by our doctors.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">3. Appointments & Cancellations</h2>
              <p>
                We value your time and our clinicians' schedules. Please provide at least 24 hours' notice for cancellations. We reserve the right to reschedule appointments in case of medical emergencies.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">4. Product Warranty</h2>
              <p>
                All eyewear and contact lenses are subject to manufacturer warranties. Siyane Optometrists provides a limited warranty for lens coatings and frame defects under normal use conditions as specified at the time of purchase.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">5. User Conduct</h2>
              <p>
                Users agree not to misuse the website or attempt to gain unauthorized access to our systems. We maintain a respectful environment for both our staff and customers at all physical branches.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">6. Limitation of Liability</h2>
              <p>
                Siyane Optometrists shall not be liable for any indirect, incidental, or consequential damages resulting from the use of our website or services, except as required by applicable consumer law.
              </p>
            </section>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default TermsOfUse;
